import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Tracks which business the signed-in user is currently acting as. Every
 * endpoint past onboarding (employees, jobs, ...) is scoped under
 * `/businesses/{business_id}/...`, and a user can belong to more than one
 * business (owner of one, employee/customer of another — see `repo.Role`).
 *
 * This only stores the raw `business_id` — resolving it to a full
 * `repo.Membership` (with `business_name`/`role`/`permissions`) happens in
 * `useCurrentBusiness()` (`src/hooks/use-current-business.ts`), which cross
 * references this id against the live `user.businesses` list and self-heals
 * if the stored id no longer matches a membership the user has.
 *
 * Persisted to localStorage (same pattern as `src/hooks/local-storage.ts`)
 * so the selection survives a page refresh.
 */
interface BusinessStoreState {
  activeBusinessId: string | null;
  setActiveBusinessId: (businessId: string | null) => void;
}

export const useBusinessStore = create<BusinessStoreState>()(
  persist(
    (set) => ({
      activeBusinessId: null,
      setActiveBusinessId: (businessId) => set({ activeBusinessId: businessId }),
    }),
    { name: 'vizitpro-active-business' },
  ),
);
